export default class AndroidProvider {
  constructor (data) {
    this.id = data.id;
    this.serverKey = data.serverKey;
    this.appId = data.appId;
    this.createdBy = data.createdBy;
    this.createdAt = data.createdAt;
    this.updatedBy = data.updatedBy;
    this.updatedAt = data.updatedAt;
  }
}
